export default __webpack_public_path__ + "static/media/question_well_config_C.858d2bef.jpg";